import IotHubLogs from "../../components/Reports/IotHubLogs";

const IotHubLogsPage = () => {
  return <IotHubLogs />;
};

export default IotHubLogsPage;
